
import { useTranslation } from "react-i18next";
const PartnerSection = () => {
    const partnerLogos = [
        "images/logos/fine-logo.webp",
        "images/logos/bahar-logo.webp",
        "images/logos/mobi-logo.webp",
        "images/logos/honey-logo.webp",
    ];
const { t } = useTranslation();
    
    return (
        <>
            <div className="container-fluid my-5">
                <div className="container py-5">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '700px' }}>
                        <div className="text-center">
                            <h1 className="fw-bold mb-3 text-secondary">{t('partners')}</h1>
                            <h6 className="fw-normal lh-base">
                                {t('partners-description')}
                            </h6>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center align-items-center gap-1 mt-5">
                        {partnerLogos.map((src, index) => (
                            <div key={index} className="d-flex align-items-center justify-content-center mx-3" style={{ height: 70 }}>
                                <img
                                    src={src}
                                    alt={t('partner-alt', { number: index + 1 })}
                                    className="img-fluid"
                                    style={{ maxHeight: 100, width: 'auto', objectFit: 'contain' }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PartnerSection;